import { Pipe, PipeTransform } from '@angular/core';
import { SnvrNetworkResource } from 'src/app/snvr/model/snvr-network-resource';
import { SNVRTask } from 'src/app/snvr/model/snvr-task';

@Pipe({
  name: 'fillPipe'
})
export class FillPipe implements PipeTransform {

  doneSpace: number = 0;
  leftSpace: number = 0;

  transform(value: any): number {
    return this.countFill(value);
  }

  countFill(value: any): number {
    if (value instanceof SnvrNetworkResource) {
      this.doneSpace = value.diskSpaceUsed;
      this.leftSpace = value.freeDiskSpace;
    }
    else if (value instanceof SNVRTask) {
      this.doneSpace = value.downloadedSize;
      this.leftSpace = value.leftToDownloadSize;
    }
    if (isNaN(this.doneSpace) || this.doneSpace < 0 || isNaN(this.leftSpace) || this.leftSpace < 0)
      return 0;
    return Math.round((this.doneSpace / (this.doneSpace + this.leftSpace)) * 100);
  }

}
